// Hover/focus effect for the SVG location pins. Pure string builder; imported by the
// three Leaflet style blocks. The inner <svg> is animated; Leaflet owns the outer marker.
export const PIN_HOVER_SELECTOR = '.leaflet-pin-icon:not(.hazard-icon):not(.route-pin-icon)';
const GLOW = 'var(--pin-glow, rgba(0, 0, 0, 0.35))';

export const PIN_HOVER_PRESETS = Object.freeze({
  statusHalo: Object.freeze({
    scale: 1.15,
    filter: `brightness(1.1) drop-shadow(0 0 1px ${GLOW}) drop-shadow(0 0 2.5px ${GLOW}) drop-shadow(0 0 4px ${GLOW})`,
    duration: '200ms',
  }),
  shadowGlow: Object.freeze({
    scale: 1.2,
    filter: 'brightness(1.15) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.45)) drop-shadow(0 2px 2.5px rgba(0, 0, 0, 0.3))',
    duration: '150ms',
  }),
});

// Swap point: change this one line to PIN_HOVER_PRESETS.shadowGlow.
export const PIN_HOVER_PRESET = PIN_HOVER_PRESETS.statusHalo;

export function pinHoverCss({ scale, filter, duration } = PIN_HOVER_PRESET) {
  const s = PIN_HOVER_SELECTOR;
  return `
    ${s} > svg {
      /* Artwork moves; Leaflet's positioned marker stays the hit target. */
      pointer-events: none;
      transform-origin: 50% 91.666667%;
      transform: scale(1);
      transition: transform ${duration} ease-out, filter ${duration} ease-out, opacity ${duration} ease-out;
    }
    @media (hover: hover) and (pointer: fine) {
      ${s}:hover > svg {
        transform: scale(${scale});
        filter: ${filter};
        opacity: 1 !important;
      }
    }
    ${s}:focus-visible > svg {
      transform: scale(${scale});
      filter: ${filter};
      opacity: 1 !important;
    }
    @media (prefers-reduced-motion: reduce) {
      ${s} > svg {
        transition: none;
      }
      ${s}:hover > svg,
      ${s}:focus-visible > svg {
        transform: none;
      }
    }
  `;
}

export const PIN_HOVER_CSS = pinHoverCss(PIN_HOVER_PRESET);
